<template>
  <div class="loader" :class="{ active: isLoaderActive }">
    <div class="loaderInner"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Loader",
  computed: {
    ...mapGetters(["isLoaderActive"])
  }
};
</script>

<style lang="scss" scoped>
.loader {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  &.active {
    display: block;
  }
  .loaderInner {
    position: absolute;
    top: 40%;
    left: 0;
    right: 0;
    margin: 0 auto;
    border-right: 0.5rem solid transparent;
    border-top: 0.5rem solid transparent;
    border-radius: 50%;
    border-color: #85c446 #85c446 transparent transparent;
    border-style: solid;
    border-width: 0.5rem;
    width: 6.25rem;
    height: 6.25rem;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
